import { CancelableType } from 'post-robot';
import { THM_ORIGIN } from 'common/environment';
import pushEvents from 'communicator/internal/push-events';
import { markEnd, markStart } from './instrumentation';
import { listenToVisaSdk, postmessageToParent } from './visa-sdk';

export type LaunchTHMOptions = {
  initialLoad?: true;
  isVisaSrci: boolean;
  orgId: string;
  sessionId: string;
};
let thmProfilingPromise: Promise<string | null> | null = null;
let thmListener: CancelableType | null = null;

export function getThmProfilingPromise() {
  return thmProfilingPromise;
}

/**
 * In Visa SRCi integrations, the Merchant SDK will refresh the THM iframe on
 * success/cancel. In these instances, we need to create a new
 * thmProfilingPromise to handle the result.
 */
export function refreshThmProfilingPromise() {
  markStart('thm');
  const startThm = Date.now();

  thmProfilingPromise = new Promise(resolve => {
    thmListener?.cancel();
    thmListener = listenToVisaSdk('visa-sdk:internal:thmProfilingComplete', e => {
      thmListener?.cancel();
      markEnd('thm');

      /* START GENAI@GHCOPILOT */
      pushEvents({
        source: window,
        origin: window.location.origin,
        data: {
          duration: Date.now() - startThm,
          E: 'BATCHED_PERFORMANCE_LOG',
          event: 'thm',
          event_action: 'thm_profiling',
          event_label: 'THM Profiling Duration',
          event_type: 'thm_profiling_duration'
        }
      });
      /* END GENAI@GHCOPILOT */

      resolve(e.data.sessionId);
    });
  });
}

export function loadThm({ initialLoad, isVisaSrci, orgId, sessionId }: LaunchTHMOptions) {
  refreshThmProfilingPromise();

  /**
   * In VSB integrations, the Merchant SDK handles THM via the launchThmIframe postmessage
   */
  if (isVisaSrci) {
    // Initial load of THM is handled by Merchant SDK. Only reload on subsequent calls
    if (!initialLoad) {
      postmessageToParent({
        data: { sessionId },
        type: 'launchThmIframe'
      });
    }

    return;
  }

  const thmFrame = document.getElementById('visa_threatmetrix_frame');

  if (thmFrame) {
    thmFrame.parentNode?.removeChild(thmFrame);
  }

  const iframe = document.createElement('iframe');
  iframe.src = `${THM_ORIGIN}/fp/tags?org_id=${orgId}&session_id=${sessionId}`;
  iframe.id = 'visa_threatmetrix_frame';

  document.body.appendChild(iframe);
}
